<template>
  <div>
    <h4>Vue AppYearPicker</h4>
    <AppYearPicker
      v-model="year"
      :start-year="startYear"
    />
  </div>
</template>
<script>
export default {
  data: () => ({
    year: 2020,
    startYear: 2010,
  }),
  computed: {},
  methods: {},
};
</script>
